import { render } from "./CookieModal.vue?vue&type=template&id=14c3f917&scoped=true"
import script from "./CookieModal.vue?vue&type=script&lang=js"
export * from "./CookieModal.vue?vue&type=script&lang=js"

import "./CookieModal.vue?vue&type=style&index=0&id=14c3f917&scoped=true&lang=css"

import exportComponent from "/home/ewerson/Projetos/vue/vitrine_digital/vitrine-crescimentoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14c3f917"]])

export default __exports__